import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-downloadedfile-icon',
  templateUrl: './files-downloadedfile.component.html'
})
export class FilesDownloadedFileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
